/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-plusplus */
/* eslint-disable react/no-unstable-nested-components */
import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { usePagination, useSortBy, useTable } from 'react-table';
import { useSticky } from 'react-table-sticky';
import IcomoonReact from 'icomoon-react';

import { setIsExerFiltersGroupShowing } from '../../ducks/sportCoachDashboardActions';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { dashboardTracker } from '../../../../shared/utils/amplitudeHelper';

const Styles = styled.div`
  align-items: flex-start;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  font-family: nunito sans;
  max-height: 70vh;
  pointer-events: auto;
  width: 100%;

  .athleteColumnHeaderCell {
    border-bottom: none;
  }

  .athleteNameTitle {
    background-color: #f0f0f0;
    color: #444444;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: bold;
    left: 0;
    max-width: 180px;
    min-width: 180px;
    position: sticky;
    text-align: left;
    top: 0;
    z-index: 4;
  }

  .footerCells {
    bottom: 0;
    color: #444444;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: normal;
    position: sticky;
    text-align: left;
    z-index: 3;
  }

  .noHoverCategoryColumnTitleCell {
    background-color: #f0f0f0;
    border-right: 1px solid #bdbdbd1a;
    color: #444444;
    font-size: 16px;
    font-weight: bold;
    max-width: 270px;
    min-width: 270px;
    position: sticky;
    top: 0;
    z-index: 3;
  }

  .pagination {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px;
  }

  .paginationButton {
    border: none;
    display: flex;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: bold;
    justify-content: center;
    padding: 5px;
  }

  .paginationContainer {
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .rawValueTitle {
    background-color: #f0f0f0;
    color: #444444;
    cursor: pointer;
    font-family: 'Nunito Sans';
    font-size: 16px;
    font-weight: normal;
    max-width: 115px;
    min-width: 115px;
    text-align: left;
  }

  & .sticky {
    margin: 25px 0px;
    overflow-x: auto;
    width: 100%;

    tfoot {
      td:first-child {
        left: 0;
        position: sticky;
        z-index: 4;
      }
    }

    [data-sticky-td] {
      position: sticky;
    }
  }

  td:has(div):has(.percentGreen) {
    background-color: #cff5e8;
  }

  td:has(div):has(.percentRed) {
    background-color: #ffcdcd;
  }

  table {
    border-collapse: separate;
    border-spacing: 0;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      background: white;
      border-bottom: 1px solid #e0e0e0;
      border-right: 1px solid #bdbdbd1a;
      margin: 0;
      padding: 15px;
      text-align: center;
    }

    tfoot {
      tr:first-child {
        td {
          background: #f0f0f0;
          border-bottom: none;
          border-bottom-left-radius: 8px;
          border-top: 1px solid #e0e0e0;
          height: 61px;
          min-height: 61px;
        }
      }
      td:first-child {
        color: #444444;
        font-family: 'Nunito Sans';
        font-size: 16px;
        font-weight: normal;
        text-align: left;
      }
      tr:last-child {
        display: none;
      }
    }
  }
`;

const Table = ({
  columns,
  data,
  getCellProps,
  getHeaderProps,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 50 },
    },
    useSticky,
    useSortBy,
    usePagination,
  );

  const dispatch = useDispatch();

  const handleMetricClick = () => {
    dashboardTracker(
      'Sport Coach Dashboard',
      'Group Analysis - Filter',
      '+Add metric clicked',
    );
    dispatch(setIsExerFiltersGroupShowing(true));
  };

  const handlePageButtonClick = (pageNum) => {
    gotoPage(pageNum);
  };

  const renderPageButtons = () => Array.from({ length: pageCount }, (_, i) => (
    <button
      className='paginationButton'
      key={i}
      onClick={() => handlePageButtonClick(i)}
      style={{ color: pageIndex === i ? '#FF6600' : '#616161' }}
      type='button'
    >
      {i + 1}
    </button>
  ));

  return (
    <>
      <div
        id='reportTable'
        style={{ display: 'flex', zIndex: 0 }}
        className='sticky'
      >
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} data-a-wrap key={headerGroup.id}>
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps([
                      {
                        className: column.className,
                      },
                      getHeaderProps(column),
                    ])}
                    data-cols-width='30'
                    data-a-wrap
                    data-f-bold
                    data-fill-color={column?.style?.fillColor || 'FF424242'}
                    data-b-a-s='thin'
                    data-b-a-c='FF000000'
                    data-f-color={
                      column?.style?.fillColor ? 'FF000000;' : 'FFFFFFFF'
                    }
                    data-a-h='center'
                    data-a-v='center'
                  >
                    {column.render('Header')}
                    <span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={10}
                            color='black'
                            icon='down-arrow'
                            style={{ marginLeft: '5px' }}
                          />
                        ) : (
                          <IcomoonReact
                            iconSet={iconSet}
                            size={10}
                            color='black'
                            icon='up-arrow'
                            style={{ marginLeft: '5px' }}
                          />
                        )
                      ) : (
                        ''
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={row.id}>
                  {row.cells.map((cell) => (
                    <td
                      {...cell.getCellProps([
                        {
                          style: cell.column.style,
                        },
                        getCellProps(cell),
                      ])}
                      data-fill-color={
                        getCellProps(cell)?.style?.fillColor || null
                      }
                      data-f-color={getCellProps(cell)?.style?.fontColor}
                      data-b-a-s='thin'
                      data-b-a-c='FF000000'
                      data-a-wrap
                    >
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            {footerGroups.map((group) => (
              <tr {...group.getFooterGroupProps()}>
                {group.headers.map((column) => (
                  <td
                    data-a-wrap
                    {...column.getFooterProps([{ className: 'footerCells' }])}
                  >
                    {column.render('Footer')}
                  </td>
                ))}
              </tr>
            ))}
          </tfoot>
        </table>
        <button
          onClick={handleMetricClick}
          style={{
            alignItems: 'center',
            background: '#5F8BDC1A',
            border: '1px dashed #5F8BDC',
            borderRadius: '5px',
            color: '#5F8BDC',
            cursor: 'pointer',
            display: 'flex',
            fontFamily: 'NunitoSans',
            fontSize: '16px',
            fontWeight: 'bold',
            justifyContent: 'center',
            margin: 0,
            minWidth: '150px',
            padding: 0,
            position: 'sticky',
            textAlign: 'center',
            top: '0',
            width: '250px',
          }}
          type='button'
        >
          <span>+ Add Exercise</span>
        </button>
      </div>
      {pageCount > 1 ? (
        <div className='paginationContainer'>
          <div className='pagination'>
            <button
              className='paginationButton'
              type='button'
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            >
              {'<'}
            </button>
            {' '}
            {renderPageButtons()}
            {' '}
            <button
              className='paginationButton'
              type='button'
              onClick={() => nextPage()}
              disabled={!canNextPage}
            >
              {'>'}
            </button>
          </div>
        </div>
      ) : null}
    </>
  );
};

const SCAnalysisTable = ({
  containerWidth,
  dataRows,
  groupAverageData,
  rowIsScrollable,
  setColumnHeaderHeight,
}) => {
  const [headerAndSubHeaderHeight, setHeaderAndSubHeaderHeight] = useState(0);
  const [isScrollable, setIsScrollable] = useState(false);

  const chartRef = useRef(null);

  const handleScroll = () => {
    // Targeting the sticky container div scroll properties
    if (!chartRef.current) return;
    const scrollWidth = chartRef.current.childNodes[0]?.scrollWidth;
    const offsetWidth = chartRef.current.childNodes[0]?.offsetWidth;
    const scrollLeft = chartRef.current.childNodes[0]?.scrollLeft;
    setIsScrollable(offsetWidth + scrollLeft !== scrollWidth);
  };

  const checkScrollability = () => {
    if (!chartRef.current) return;
    const scrollWidth = chartRef.current.childNodes[0]?.scrollWidth;
    const offsetWidth = chartRef.current.childNodes[0]?.offsetWidth;
    const scrollLeft = chartRef.current.childNodes[0]?.scrollLeft;
    setIsScrollable(offsetWidth + scrollLeft !== scrollWidth);
  };

  const setHeights = () => {
    if (!chartRef.current) return;
    setHeaderAndSubHeaderHeight(
      chartRef.current.childNodes[0].childNodes[0].childNodes[0].clientHeight,
    );
    setColumnHeaderHeight(
      chartRef.current.childNodes[0].childNodes[0].childNodes[0].childNodes[0]
        .clientHeight,
    );
  };

  useEffect(() => {
    checkScrollability();
  }, []);

  useEffect(() => {
    setHeights();
  }, [setColumnHeaderHeight]);

  const athleteNameColumn = [
    {
      Header: '',
      Footer: () => null,
      id: 'name',
      className: 'athleteColumnHeaderCell',
      columns: [
        {
          Header: 'Athlete',
          accessor: 'fullName',
          Footer: 'Group Average',
          className: 'athleteNameTitle',
          style: {
            // style for the whole column
            // className is style for just the header
            borderRight: '1px solid #E0E0E0',
            color: '#444444',
            fontFamily: 'Nunito Sans',
            fontSize: '16px',
            fontWeight: 'normal',
            height: '58px',
            left: '0',
            position: 'sticky',
            textAlign: 'left',
          },
          Cell: ({ row }) => (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <div
                style={{
                  borderRadius: '50%',
                  height: '35px',
                  marginRight: '5px',
                  overflow: 'hidden',
                  width: '35px',
                }}
              >
                <img
                  alt={`${row.original.fullName} icon`}
                  src={row.original.pic}
                  style={{ height: '100%' }}
                />
              </div>
              <div>{row.original.fullName}</div>
            </div>
          ),
        },
      ],
    },
  ];

  const formatColumns = () => {
    const formattedData = dataRows[0].results.map((exer, i) => ({
      Header: exer.exerName,
      Footer: () => null,
      id: exer.exerName,
      className: 'noHoverCategoryColumnTitleCell',
      columns: [
        {
          Header: 'Start',
          accessor: (row) => {
            const value = row.results[i].oldestMax;
            return value !== '-' && value !== null ? parseFloat(value) : null;
          },
          sortType: (rowA, rowB, columnId, desc) => {
            const a = rowA.values[columnId];
            const b = rowB.values[columnId];

            if (a === null && b === null) return 0;
            if (a === null) return desc ? -1 : 1;
            if (b === null) return desc ? 1 : -1;

            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          },
          Cell: ({ row }) => {
            const value = row.original.results[i].oldestMax;
            if (row.original.results[i].color === '#FFCB47') {
              return <div className='percentRed'>{value}</div>;
            }
            if (row.original.results[i].color === '#0DCC8A') {
              return <div className='percentGreen'>{value}</div>;
            }
            return <div>{value || '-'}</div>;
          },
          Footer: () => {
            const total = groupAverageData.map((obj) => obj.oldestAverage);
            return total[i] || '-';
          },
          id: `${exer.exerName}_start`,
          className: 'rawValueTitle',
          style: {
            minWidth: '90px',
            maxWidth: '90px',
            textAlign: 'left',
            fontFamily: 'Nunito Sans',
            fontSize: '16px',
            fontWeight: 'normal',
            color: '#444444',
          },
        },
        {
          Header: 'End',
          accessor: (row) => {
            const value = row.results[i].newestMax;
            return value !== '-' && value !== null ? parseFloat(value) : null;
          },
          sortType: (rowA, rowB, columnId, desc) => {
            const a = rowA.values[columnId];
            const b = rowB.values[columnId];

            if (a === null && b === null) return 0;
            if (a === null) return desc ? -1 : 1;
            if (b === null) return desc ? 1 : -1;

            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          },
          Cell: ({ row }) => {
            const value = row.original.results[i].newestMax;
            if (row.original.results[i].color === '#FFCB47') {
              return <div className='percentRed'>{value}</div>;
            }
            if (row.original.results[i].color === '#0DCC8A') {
              return <div className='percentGreen'>{value}</div>;
            }
            return <div>{value || '-'}</div>;
          },
          Footer: () => {
            const total = groupAverageData.map((obj) => obj.newestAverage);
            return total[i] || '-';
          },
          id: `${exer.exerName}_end`,
          className: 'rawValueTitle',
          style: {
            minWidth: '90px',
            maxWidth: '90px',
            textAlign: 'left',
            fontFamily: 'Nunito Sans',
            fontSize: '16px',
            fontWeight: 'normal',
            color: '#444444',
          },
        },
        {
          Header: 'Change',
          accessor: (row) => {
            const value = row.results[i].percentChange;
            return value !== '-' && value !== null ? parseFloat(value) : null;
          },
          sortType: (rowA, rowB, columnId, desc) => {
            const a = rowA.values[columnId];
            const b = rowB.values[columnId];

            if (a === null && b === null) return 0;
            if (a === null) return desc ? -1 : 1;
            if (b === null) return desc ? 1 : -1;

            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          },
          Cell: ({ row }) => {
            const value = row.original.results[i].percentChange;
            if (value === '-' || value === null) return '-';
            const { color } = row.original.results[i];
            return (
              <div
                className={
                  color === '#FFCB47'
                    ? 'percentRed'
                    : color === '#0DCC8A'
                      ? 'percentGreen'
                      : ''
                }
              >
                {value}
                %
              </div>
            );
          },
          Footer: () => {
            const total = groupAverageData.map((obj) => obj.percentChange);
            return total[i] ? `${total[i]}%` : '-';
          },
          id: `${exer.exerName}_change`,
          className: 'rawValueTitle',
          style: {
            minWidth: '90px',
            maxWidth: '90px',
            textAlign: 'left',
            fontFamily: 'Nunito Sans',
            fontSize: '16px',
            fontWeight: 'normal',
            color: '#444444',
          },
        },
      ],
    }));
    return formattedData;
  };

  const formattedMiddleColumns = formatColumns();
  const columns = [...athleteNameColumn, ...formattedMiddleColumns];
  const memoizedColumns = useMemo(() => columns, [dataRows, groupAverageData]);
  const memoizedDataRows = useMemo(() => dataRows, [dataRows]);

  const handleHeaderClick = (headerInfo) => {
    if (headerInfo.Header !== '') {
      headerInfo.toggleSortBy();
    }
  };

  return (
    <Styles
      ref={chartRef}
      onScroll={handleScroll}
      isScrollable={isScrollable}
      rowIsScrollable={rowIsScrollable}
      headerAndSubHeaderHeight={headerAndSubHeaderHeight}
      containerWidth={containerWidth}
    >
      <Table
        containerWidth={containerWidth}
        columns={memoizedColumns}
        data={memoizedDataRows}
        getCellProps={() => ({
          style: {
            backgroundColor: 'FFFFFFFF',
            color: 'FF444444',
            fillColor: 'FFFFFFFF',
            fontColor: 'FF444444',
          },
        })}
        getHeaderProps={(headerInfo) => ({
          onClick: () => handleHeaderClick(headerInfo),
        })}
      />
    </Styles>
  );
};

export default SCAnalysisTable;
